/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { TColorIcon, THueVariationString, TSize, TTextColor } from 'volta/utils/style-utils';

import templateOnlyComponent from '@ember/component/template-only';

export interface IBvIconArgs {
  color?: THueVariationString | TColorIcon | TTextColor;
  glyph?: string;
  hasBackdrop?: boolean;
  label?: string;
  onClick?: (e: MouseEvent) => void;
  size?: TSize;
  tooltip?: string;
  tooltipSide?: 'top' | 'bottom' | 'left' | 'right';
  class?: string;
}

export interface BvIconSignature {
  Args: IBvIconArgs;
  Blocks: {
    default: [];
  };
  Element: HTMLSpanElement;
}

const BvIconComponent = templateOnlyComponent<BvIconSignature>();

export default BvIconComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvIcon: typeof BvIconComponent;
    'bv-icon': typeof BvIconComponent;
  }
}
